import { useState } from "react";
import {
  ResponseGetUserListResonse,
  RequestGetUserListRequest,
  UsersGetUserListPostRequest,
  UsersApi,
} from "../../services/OpenAPI";
import { createConfiguration } from "./common";

export const useApiGetUserList = () => {
  const [userList, setUserList] = useState<ResponseGetUserListResonse[] | null>(
    []
  );
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchUserList = async (requestParams: RequestGetUserListRequest) => {
    setIsLoading(true);
    setError(null);

    try {
      const config = createConfiguration();
      const request: UsersGetUserListPostRequest = {
        req: requestParams,
      };

      const api = new UsersApi(config);
      const response = await api.usersGetUserListPost(request);
      setUserList(response);
      return response;
    } catch (err) {
      setError("ユーザーリストの取得に失敗しました");
      console.error(err);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { userList, fetchUserList, error, isLoading };
};
